import type {ReactElement} from 'react';
import {useContext} from 'react';
import {Text, TextSize} from '@Components/text';
import {Swatches} from '@Components/color-picker-v2/components/swatches';
import {getSwatchesLayout} from '@Components/color-picker-v2/components/swatches/swatches-library';
import {DEFAULT_PRESETS} from '@Components/color-picker-mobile/components/default-preset-section/default-preset-section.types';
import type {RGBA} from '@Utils/color.util';
import {hexToRgba, rgbToHexString} from '@Utils/color.util';
import {ColorPickerLayoutContext} from '@Components/color-picker-v2/color-picker-layout-context';
import {ColorPickerLayout} from '@Components/color-picker-v2/color-picker-v2.types';
import styles from './default-preset-section.module.scss';

interface DefaultPresetSectionProps {
  className?: string;

  onChangeColor(color: RGBA): void;
  isMobileVariant?: boolean;
}

export function DefaultPresetSection({isMobileVariant = true, className = '', ...props}: DefaultPresetSectionProps): ReactElement<any> | null {
  const colorPickerLayout = useContext(ColorPickerLayoutContext);
  const isPopupLayout = colorPickerLayout === ColorPickerLayout.POPUP;
  const hasHeadingDivider = !isMobileVariant && !isPopupLayout;
  const getColorsInHex = (): string[] => {
    const colors = [];
    for (const eachRGB of DEFAULT_PRESETS) {
      colors.push(rgbToHexString(eachRGB));
    }
    return colors;
  };

  return (
    <div className={`flex-v-row ${className} ${!isMobileVariant ? 'spacing-m-t-6' : ''}`}>
      <Text
        className={`content-body ${hasHeadingDivider ? styles.text : ''}`}
        size={isMobileVariant ? TextSize.XXSMALL : TextSize.XSMALL}
        bold
        val={window.i18next.t('pmwjs_default_presets')}
      />
      <Swatches
        className={isPopupLayout ? 'spacing-m-t-3' : 'spacing-m-t-2'}
        colors={getColorsInHex()}
        onClick={(color: string): void => {
          props.onChangeColor(hexToRgba(color));
        }}
        showAddButton={false}
        hasCustomMargins
        layout={getSwatchesLayout(colorPickerLayout, isMobileVariant)}
      />
    </div>
  );
}
